import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

i18next.use(initReactI18next).init({
  lng: process.env.REACT_APP_LANG,
  debug: false,
  resources: {
    ru: {
      translation: ru,
    },
    en: {
      translation: en,
    },
  },
  returnNull: false,
});

export default i18next;
